import { render, staticRenderFns } from "./FeaturedView.vue?vue&type=template&id=6eaabfbe&scoped=true&"
import script from "./FeaturedView.vue?vue&type=script&lang=js&"
export * from "./FeaturedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaabfbe",
  null
  
)

export default component.exports